

// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../../../../../utils/index";
// import Form from "react-bootstrap/Form";
// import { useAuthHeaders } from "../../../../../components/Token";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { GETSinglesubcategory, UpdatesubcategoryVendor } from "../../../../../services/api/Subcategory";

// function EditVendorSubCategory() {
//   const { _id } = useParams();
//   const [newSubCategoryName, setNewSubCategoryName] = useState("");
//   const navigate = useNavigate();
//   const [categories, setCategories] = useState("");
//   const subdomain = localStorage.getItem("vendorsubdomain")
//   const headers = useAuthHeaders();


//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await GETSinglesubcategory(subdomain, _id)
//       if (response.success) {
//         setNewSubCategoryName(response?.subcategory?.name);
//         setCategories(response?.subcategory?.category);
//         console.log("response in singlesubcategory", response);
//       }
//     }
//     fetchData()

//   }, []);

//   const handleSave = async (e) => {
//     e.preventDefault();
//     const data = { name: newSubCategoryName, categoryId: categories._id };

//     const response = await UpdatesubcategoryVendor(subdomain, data, _id)
//     if (response.success) {
//       navigate(`/${subdomain}/master/sub-category`)
//     }
//     // axios
//     //   .put(`${API_BASE_URL}/subcategory/admin/updatesubcategory/${_id}`, data, {
//     //     headers,
//     //   })
//     //   .then((response) => {
//     //     console.log("response :", response);
//     //     navigate("/subCategory");
//     //   })
//     //   .catch((error) => {
//     //     console.error("Error updating category:", error);
//     //     Swal.fire({
//     //       icon: "error",
//     //       title: "Oops...",
//     //       text: error.response.data.error,
//     //     });
//     //   });
//   };

//   return (
//     <div className="p-3">
//       <h2>Edit Sub Category</h2>
//       <form onSubmit={handleSave} className="category" style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset" }}>
//         <div className="category-field">
//           <div className="d-flex">
//             <label className="fs-6 fw-bold">Category Name:</label>
//             <br />
//             <p className="mx-2">{categories.name}</p>
//           </div>

//           <label htmlFor="name" className="fs-6 fw-bold">
//             Change Sub Category Name:
//           </label>
//           <br />
//           <input
//             type="text"
//             id="name"
//             value={newSubCategoryName}
//             onChange={(e) => setNewSubCategoryName(e.target?.value)}
//           />
//         </div>
//         <div className="buttons">
//           <button type="submit" style={{ backgroundColor: "#0443C0", color: "white" }}>Save</button>
//           <button style={{ backgroundColor: "#F04B25", color: "white" }} onClick={() => navigate(`/${subdomain}/master/sub-category`)}>Cancel</button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default EditVendorSubCategory;


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Snackbar,
  Alert,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthHeaders } from "../../../../../components/Token";
import { GETSinglesubcategory, UpdatesubcategoryVendor } from "../../../../../services/api/Subcategory";

function EditVendorSubCategory() {
  const { _id } = useParams();
  const [newSubCategoryName, setNewSubCategoryName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const subdomain = localStorage.getItem("vendorsubdomain");
  const headers = useAuthHeaders();

  useEffect(() => {
    const fetchData = async () => {
      const response = await GETSinglesubcategory(subdomain, _id);
      if (response.success) {
        setNewSubCategoryName(response?.subcategory?.name);
        setCategoryName(response?.subcategory?.category?.name);
      } else {
        setSnackbar({ open: true, message: "Failed to load data", severity: "error" });
      }
    };
    fetchData();
  }, [_id, subdomain]);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = { name: newSubCategoryName };
      const response = await UpdatesubcategoryVendor(subdomain, data, _id);
      if (response.success) {
        setSnackbar({
          open: true,
          message: response.message,
          severity: "success",
        });
        navigate(`/${subdomain}/master/sub-category`)
      } else {
        setSnackbar({
          open: true,
          message: response.message,
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to update subcategory",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${subdomain}/master/sub-category`);
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Edit Sub Category
      </Typography>

      <Paper elevation={3} sx={{ p: 3, maxWidth: 600 }}>
        <form onSubmit={handleSave}>
          <Box mb={2}>
            <Typography variant="subtitle2">Category Name:</Typography>
            <Typography variant="body1" sx={{ ml: 1 }}>{categoryName}</Typography>
          </Box>

          <TextField
            fullWidth
            label="Sub Category Name"
            variant="outlined"
            value={newSubCategoryName}
            onChange={(e) => setNewSubCategoryName(e.target.value)}
            required
            sx={{ mb: 3 }}
          />

          <Box display="flex" gap={2}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              {loading ? "Saving..." : "Save"}
            </Button>

            <Button variant="contained" color="error" onClick={handleCancel}>
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default EditVendorSubCategory;
